module.exports = require("@mui/icons-material/Replay");